@if (!isLoading && stickerProduct) {
  <div class="gulli-sticker-section">
    <div class="sticker-card">
      <div class="sticker-badge">NEW</div>
      <div class="sticker-image-container">
        <img
          [src]="stickerProduct.imageUrl"
          alt="Gulli Sticker"
          class="sticker-image"
          (error)="onImageError($event)">
        @if (hasDiscount()) {
          <div class="discount-badge">
            -{{ getDiscountPercentage() }}%
          </div>
        }
      </div>
      <div class="sticker-info">
        <h2>{{ 'HOME.GULLI_STICKER.TITLE' | translate }}</h2>
        <p class="sticker-tagline">{{ 'HOME.GULLI_STICKER.TAGLINE' | translate }}</p>
        <p class="sticker-description">{{ 'HOME.GULLI_STICKER.DESCRIPTION' | translate }}</p>
        <div class="sticker-pricing">
          <span class="sticker-price">{{ formatPrice(stickerProduct.price.amount, stickerProduct.price.currencyCode) }}</span>
          @if (hasDiscount()) {
            <span class="sticker-compare-price">
              {{ formatPrice(stickerProduct.compareAtPrice!.amount, stickerProduct.compareAtPrice!.currencyCode) }}
            </span>
          }
        </div>
        <button class="sticker-add-to-cart-btn" (click)="addToCart()">
          {{ 'HOME.GULLI_STICKER.ADD_TO_CART' | translate }}
        </button>
      </div>
    </div>
    <!-- Added to Cart Notification -->
    <div class="cart-notification" [class.show]="showAddedToCartNotification">
      <div class="cart-notification-content">
        <img loading="lazy" src="../../../assets/images/CheckCircle.svg" alt="Success" class="notification-icon">
        <div class="notification-text">
          <strong>{{ stickerProduct.title }}</strong>
          <span>{{ 'HOME.GULLI_STICKER.ADDED_TO_CART' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
}

<!-- Loading skeleton -->
@if (isLoading) {
  <div class="gulli-sticker-section">
    <div class="sticker-card skeleton">
      <div class="skeleton-image"></div>
      <div class="skeleton-info">
        <div class="skeleton-title"></div>
        <div class="skeleton-text"></div>
        <div class="skeleton-text short"></div>
        <div class="skeleton-price"></div>
        <div class="skeleton-button"></div>
      </div>
    </div>
  </div>
}
